<template>
	<v-app>
		<div v-if="$myStore.state.loaderCount > 0" class="loader">
			<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
		</div>

		<v-dialog v-model="alertModal.show" max-width="480">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text class="grey--text text--darken-2" v-html="alertModal.text"></v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="alertModal.show = false">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="verifyModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2" v-html="verifyModal.text"></v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="verifyModal.result(true)">{{ $t('buttons.yes') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModal.result(false)">{{ $t('buttons.no') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="verifyModalShortForm.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2" v-html="verifyModalShortForm.text"></v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="verifyModalShortForm.result(true)">{{ $t('buttons.yes') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModalShortForm.result(false)">{{ $t('buttons.filOutFullApplication') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="verifyModalShortFormExisting.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2" v-html="verifyModalShortFormExisting.text"></v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="verifyModalShortFormExisting.result(true)">{{
						$t('buttons.applyForThisJob')
					}}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModalShortFormExisting.result(false)">{{ $t('buttons.cancel') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="promptModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text class="grey--text text--darken-2">
					<InputField v-model="promptModal.value" :label="promptModal.text"></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="promptModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="promptModal.result(false)">{{ $t('buttons.cancel') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar
			v-model="notification.show"
			:timeout="3000"
			:top="true"
			class="notification black--text text-center"
			color="primary"
			>{{ notification.text }}
		</v-snackbar>

		<v-main v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view></router-view>
			</transition>
		</v-main>
	</v-app>
</template>

<script>
import InputField from './components/trinkets/InputField';

export default {
	name: 'App',
	components: { InputField },
	data() {
		return {
			drawer: null,
			alertModal: {
				show: false,
				text: '',
			},
			verifyModal: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModal.show = false;
					this.verifyModal.reaction(result);
				},
				reaction: () => {},
			},
			verifyModalShortForm: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModalShortForm.show = false;
					this.verifyModalShortForm.reaction(result);
				},
				reaction: () => {},
			},
			verifyModalShortFormExisting: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModalShortFormExisting.show = false;
					this.verifyModalShortFormExisting.reaction(result);
				},
				reaction: () => {},
			},
			promptModal: {
				show: false,
				text: '',
				value: '',
				result: (result) => {
					this.promptModal.show = false;
					if (result !== false) {
						this.promptModal.reaction(this.promptModal.value);
					} else {
						this.promptModal.reaction(false);
					}
				},
				reaction: () => {},
			},
			notification: {
				show: false,
				text: '',
			},
			initialLoadCompleted: false,
			breadcrumbs: [],
			publicPath: process.env.BASE_URL,
		};
	},
	computed: {},
	methods: {
		logoutClick() {
			let vm = this;
			this.$APICall('post', 'logout', {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', null);
					vm.$myStore.commit('setLoggedIn', false);
					vm.$router.push('/login');
				}
			});
		},
		profileClick() {
			this.$router.push('/profile');
		},
		logoClick() {
			this.$router.push('/dashboard');
		},
		showPDF(fileName) {
			window.open(process.env.BASE_URL + fileName + '.pdf');
		},
	},
	mounted() {
		var vm = this;
		this.initialLoadCompleted = true;
		if (
			this.$router.currentRoute.name !== 'vacancies' &&
			this.$router.currentRoute.name !== 'openApplication' &&
			this.$router.currentRoute.name !== 'vacancyApplication' &&
			this.$router.currentRoute.name !== 'openApplicationExistingSeafarer' &&
			this.$router.currentRoute.name !== 'vacancyApplicationExistingSeafarer'
		) {
			this.$router.push('/vacancies');
		}

		this.$vuetify.theme.themes.light.primary = '#009ec0';
		this.$vuetify.theme.themes.light.secondary = '#858585';

		this.$modalBus.$on('ALERT', (message) => {
			vm.alertModal.text = message;
			vm.alertModal.show = true;
		});
		this.$modalBus.$on('VERIFY', (data) => {
			vm.verifyModal.text = data.message;
			vm.verifyModal.reaction = data.response;
			vm.verifyModal.show = true;
		});
		this.$modalBus.$on('VERIFYSHORT', (data) => {
			vm.verifyModalShortForm.text = data.message;
			vm.verifyModalShortForm.reaction = data.response;
			vm.verifyModalShortForm.show = true;
		});
		this.$modalBus.$on('VERIFYSHORTEXISTING', (data) => {
			vm.verifyModalShortFormExisting.text = data.message;
			vm.verifyModalShortFormExisting.reaction = data.response;
			vm.verifyModalShortFormExisting.show = true;
		});
		this.$modalBus.$on('PROMPT', (data) => {
			vm.promptModal.text = data.message;
			vm.promptModal.value = data.initial;
			vm.promptModal.reaction = data.response;
			vm.promptModal.show = true;
		});
		this.$modalBus.$on('NOTIFY', (message) => {
			vm.notification.text = message;
			vm.notification.show = true;
		});
	},
};
</script>

<style scoped>
@font-face {
	font-family: 'Nunito-Regular';
	src: url('~@/assets/fonts/Nunito-Regular.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
	font-display: auto;
}

@font-face {
	font-family: 'Maitree-Regular';
	src: url('~@/assets/fonts/Maitree-Regular.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
	font-display: auto;
}

.notification {
	z-index: 999999;
}

.loader {
	position: fixed;
	left: 0px;
	top: 0px;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	font-size: 100px;
	text-align: center;
	padding-top: 100px;
}

.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 1s;
}

.fade-to {
	opacity: 1;
}

>>> .cursor-pointer {
	cursor: pointer;
}

>>> .v-main {
	background-color: rgba(235, 242, 244, 255);
	color: rgba(5, 75, 97, 255);
	font-family: 'Nunito-Regular', sans-serif;
	font-style: normal;
}

.menu-footer {
	position: fixed;
	bottom: 10px;
	width: 100%;
	text-align: center;
}

>>> .menu-footer a {
	text-decoration: none;
}

>>> .action-bar {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	z-index: 9;
	background-color: #efefef;
	text-align: center;
	-webkit-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	-moz-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
}

.navigation-items {
	margin-bottom: 50px;
}
</style>
